import { IDictionary } from '@bimser/core';
import DataGrid2 from '../../..';

export async function insertRows(this: DataGrid2, data: IDictionary<any>[]) {
	await this.rowChangeAction(
		data.map(row => ({
			type: 'insert',
			key: row[this.getUniqueDataField()],
			data: row
		}))
	);
}
